export const disposer = () => { };
//# sourceMappingURL=disposer.js.map